<template>
  <el-container direction="vertical" style="height: 100%">
    <el-header height="50px">
      <el-row>
        <el-col :span="20">
          <div style="display: flex">
            <img
              class="logo"
              src="../assets/img/logo.a13e.svg"
              alt="logo"
            />
            <!-- <span class="headtitle">{{$t('message.TR小程序管理系统')}}</span> -->
            <div style="width: 80px"></div>
            <el-menu
              :default-active="menuIndex"
              mode="horizontal"
              :unique-opened="true"
              active-text-color="#ccc"
              background-color="#434B51"
              text-color="#ccc"
              :router="true"
              style="height: 50px; font-size: 12px"
            >
              <!-- <el-menu-item @click="
                  setTitle('小美配置项');
                  setMenuIndex('/tanchu');
                " :index="'/tanchu'">
                <span slot="title">{{ $t("message.小美配置项") }}</span>
              </el-menu-item> -->

              <el-submenu index="5" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>用户信息收集</span>
                </template>
                <!-- <el-menu-item
                  @click="
                    setTitle('角色管理');
                    setMenuIndex('/role');
                    setSubTitle('会员中心');
                  "
                  :index="'/role'"
                >
                  <span slot="title">{{ $t("message.角色管理") }}</span>
                </el-menu-item> -->
                <el-menu-item
                  @click="
                    setTitle('会员管理');
                    setMenuIndex('/vip');
                    setSubTitle('用户信息收集');
                  "
                  :index="'/vip'"
                >
                  用户信息
                </el-menu-item>
                
                <el-menu-item
                  @click="
                    setTitle('用户事件');
                    setMenuIndex('/userCondition');
                    setSubTitle('用户信息收集');
                  "
                  :index="'/userCondition'"
                >
                  {{ $t("message.用户事件") }}
                </el-menu-item>

                <el-menu-item
                  @click="
                    setTitle('用户维度');
                    setMenuIndex('/userDimension');
                    setSubTitle('用户信息收集');
                  "
                  :index="'/userDimension'"
                >
                  用户维度
                </el-menu-item>

                <el-menu-item
                  @click="
                    setTitle('内容维度');
                    setMenuIndex('/articleDimension');
                    setSubTitle('用户信息收集');
                  "
                  :index="'/articleDimension'"
                >
                  内容维度
                </el-menu-item>

                <el-menu-item
                  @click="
                    setTitle('我的维度');
                    setMenuIndex('/myDimension');
                    setSubTitle('用户信息收集');
                  "
                  :index="'/myDimension'"
                >
                  我的维度
                </el-menu-item>

                <el-menu-item
                  @click="
                    setTitle('资源位');
                    setMenuIndex('/clickDimension');
                    setSubTitle('用户信息收集');
                  "
                  :index="'/clickDimension'"
                >
                  资源维度
                </el-menu-item>

                <el-menu-item
                  @click="
                    setTitle('搜索维度');
                    setMenuIndex('/searchDimension');
                    setSubTitle('用户信息收集');
                  "
                  :index="'/searchDimension'"
                >
                  搜索维度
                </el-menu-item>

                <!-- <el-menu-item
                  @click="
                    setTitle('订单管理');
                    setMenuIndex('/order');
                    setSubTitle('运营工具');
                  "
                  :index="'/order'"
                >
                  订单管理
                </el-menu-item>
                <el-menu-item
                  @click="
                    setTitle('活动记录');
                    setMenuIndex('/useractivitytable');
                    setSubTitle('活动记录');
                  "
                  :index="'/useractivitytable'"
                >
                  活动记录
                </el-menu-item> -->

                <!-- <el-submenu index="5-6">
                  <template slot="title">{{ $t("message.用户积分管理") }}</template>

                  <el-menu-item
                    @click="
                      setTitle('积分获取记录');
                      setMenuIndex('/userPoint');
                      setSubTitle('积分获取记录');
                    "
                    :index="'/userPoint'"
                  >
                    积分获取记录
                  </el-menu-item>

                  <el-menu-item
                    @click="
                      setTitle('积分消费记录');
                      setMenuIndex('/userPointConsume');
                      setSubTitle('积分消费记录');
                    "
                    :index="'/userPointConsume'"
                  >
                    积分消费记录
                  </el-menu-item>
                </el-submenu> -->
              </el-submenu>

              <!-- <el-submenu index="9" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>积分管理</span>
                </template>
                <el-menu-item
                  @click="
                    setTitle('积分组');
                    setMenuIndex('/pointgrouplist');
                    setSubTitle('积分组');
                  "
                  :index="'/pointgrouplist'"
                >
                  {{ $t("message.积分组") }}</el-menu-item
                >
                <el-menu-item
                  @click="
                    setTitle('积分获取方式');
                    setMenuIndex('/pointgainlist');
                    setSubTitle('积分获取方式');
                  "
                  :index="'/pointgainlist'"
                >
                  {{ $t("message.积分获取") }}</el-menu-item
                >
                                <el-menu-item
                  @click="
                    setTitle('积分排行榜');
                    setMenuIndex('/pointrank');
                    setSubTitle('积分获取方式');
                  "
                  :index="'/pointrank'"
                >
                  {{ $t("message.积分排行榜") }}</el-menu-item
                >
              </el-submenu> -->

              <el-submenu index="8" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <!-- <i class="el-icon-table-lamp"></i> -->
                  <span>{{ $t("message.小美页面管理") }}</span>
                </template>
                <el-menu-item
                  @click="
                    setTitle('小美首页管理');
                    setMenuIndex('/homeEdit');
                    setSubTitle('小美首页管理');
                  "
                  :index="'/homeEdit'"
                >
                  {{ $t("message.小美首页管理") }}</el-menu-item
                >
                <!-- <el-menu-item
                  @click="
                    setTitle('小美福利管理');
                    setMenuIndex('/welfare');
                    setSubTitle('小美福利管理');
                  "
                  :index="'/welfare'"
                  >{{ $t("message.小美福利管理") }}</el-menu-item
                > -->
                <el-menu-item
                  @click="
                    setTitle('小美配置项');
                    setMenuIndex('/tanchu');
                    setSubTitle('小美配置项');
                  "
                  :index="'/tanchu'"
                >
                  {{ $t("message.小美配置项") }}</el-menu-item
                >
              </el-submenu>

              <!-- <el-submenu index="7" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>{{ $t("message.活动") }}</span>
                </template>
                <el-menu-item
                  @click="
                    setTitle('活动设置');
                    setMenuIndex('/appointmanagement');
                    setSubTitle('活动');
                  "
                  :index="'/appointmanagement'"
                >
                  {{ $t("message.活动设置") }}</el-menu-item
                >
                <el-menu-item
                  @click="
                    setTitle('奖品库存');
                    setMenuIndex('/storecount');
                    setSubTitle('活动');
                  "
                  :index="'/storecount'"
                >
                  {{ $t("message.奖品库存") }}</el-menu-item
                >
                                <el-menu-item
                  @click="
                    setTitle('MGM活动管理');
                    setMenuIndex('/mgmList');
                    setSubTitle('活动');
                  "
                  :index="'/mgmList'"
                >
                  {{ $t("message.MGM活动管理") }}</el-menu-item
                >
                                           <el-menu-item
                  @click="
                    setTitle('MGM活动排行榜');
                    setMenuIndex('/mgmrank');
                    setSubTitle('活动');
                  "
                  :index="'/mgmrank'"
                >
                  {{ $t("message.MGM活动排行榜") }}</el-menu-item
                >
              </el-submenu> -->

              <el-submenu index="1" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <!-- <i class="el-icon-table-lamp"></i> -->
                  <span>分类&推荐关键词</span>
                </template>
                <!-- <el-menu-item
                  @click="
                    setTitle('产品热搜榜管理');
                    setMenuIndex('/toplist');
                    setSubTitle('产品');
                  "
                  :index="'/toplist'"
                >
                  {{ $t("message.产品热搜榜管理") }}</el-menu-item
                > -->
                <el-menu-item
                  @click="
                    setTitle('分类管理');
                    setMenuIndex('/classifylist');
                    setSubTitle('产品');
                  "
                  :index="'/classifylist'"
                  >{{ $t("message.分类管理") }}</el-menu-item
                >
                <!-- <el-menu-item
                  @click="
                    setTitle('产品管理');
                    setMenuIndex('/productlist');
                    setSubTitle('产品');
                  "
                  :index="'/productlist'"
                >
                  {{ $t("message.产品管理") }}</el-menu-item
                > -->
                <el-menu-item
                  @click="
                    setTitle('推荐搜索关键词管理');
                    setMenuIndex('/searchrecommend');
                    setSubTitle('产品');
                  "
                  :index="'/searchrecommend'"
                >
                  {{ $t("message.推荐搜索关键词管理") }}</el-menu-item
                >
              </el-submenu>

              <!-- <el-submenu index="2" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>{{ $t("message.品牌") }}</span>
                </template>
                <el-menu-item
                  @click="
                    setTitle('品牌详情类型管理');
                    setMenuIndex('/brandtypelist');
                    setSubTitle('品牌');
                  "
                  :index="'/brandtypelist'"
                  >{{ $t("message.品牌详情类型管理") }}</el-menu-item
                >
                <el-menu-item
                  @click="
                    setTitle('品牌管理');
                    setMenuIndex('/brandlist');
                    setSubTitle('品牌');
                  "
                  :index="'/brandlist'"
                  >{{ $t("message.品牌管理") }}
                </el-menu-item>
              </el-submenu> -->

              <!-- <el-submenu index="3" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>{{ $t("message.运营工具") }}</span>
                </template>
                <el-menu-item @click="setTitle('标签管理'); setMenuIndex('/tagmanage'); setSubTitle('运营工具')" :index="'/tagmanage'">
                  {{$t('message.标签管理')}}
                </el-menu-item>
                <el-menu-item @click="setTitle('标签清洗'); setMenuIndex('/committag'); setSubTitle('运营工具')" :index="'/committag'">
                  {{$t('message.标签清洗')}}
                </el-menu-item>
                <el-menu-item @click="setTitle('第三方平台授权'); setMenuIndex('/preauth'); setSubTitle('运营工具')" :index="'/preauth'">
                  {{$t('message.第三方平台授权')}}
                </el-menu-item>
              </el-submenu> -->

              <!-- <el-submenu index="4" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>{{ $t("message.组织架构") }}</span>
                </template>
                <el-menu-item
                  @click="
                    setTitle('组织管理');
                    setMenuIndex('/organization');
                    setSubTitle('组织架构');
                  "
                  :index="'/organization'"
                >
                  <span slot="title">{{ $t("message.组织管理") }}</span>
                </el-menu-item>
                <el-menu-item
                  @click="
                    setTitle('员工管理');
                    setMenuIndex('/employee');
                    setSubTitle('组织架构');
                  "
                  :index="'/employee'"
                >
                  {{ $t("message.员工管理") }}
                </el-menu-item>
                <el-menu-item
                  @click="
                    setTitle('门店管理');
                    setMenuIndex('/shopmanagement');
                    setSubTitle('活动');
                  "
                  :index="'/shopmanagement'"
                >
                  {{ $t("message.门店管理") }}</el-menu-item
                >
              </el-submenu> -->
              <!-- <el-menu-item
                @click="
                  setTitle('订阅消息');
                  setMenuIndex('/scribe');
                  setSubTitle('订阅消息');
                "
                :index="'/scribe'"
                >订阅消息</el-menu-item
              > -->
              <el-menu-item
                @click="
                  setTitle('文章管理');
                  setMenuIndex('/articleList');
                  setSubTitle('文章管理');
                "
                :index="'/articleList'"
                >文章管理</el-menu-item
              >

              <el-submenu index="10" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>留言板管理</span>
                </template>

                <!-- <el-menu-item
                  @click="
                    setTitle('留言板管理');
                    setMenuIndex('/messageList');
                    setSubTitle('留言板管理');
                  "
                  :index="'/messageList'"
                  >{{ $t("message.留言板管理") }}</el-menu-item
                > -->

                <el-menu-item
                  @click="
                    setTitle('留言板列表');
                    setMenuIndex('/messageBoard');
                    setSubTitle('留言板列表');
                  "
                  :index="'/messageBoard'"
                  >{{ $t("message.留言板列表") }}</el-menu-item
                >

              </el-submenu>
              

              <el-submenu index="9" :show-timeout="100" :hide-timeout="0">
                <template slot="title">
                  <span>兴趣标签管理</span>
                </template>
                <el-menu-item
                  @click="
                    setTitle('标签分组');
                    setMenuIndex('/interestedtaggrouplist');
                    setSubTitle('标签分组');
                  "
                  :index="'/interestedtaggrouplist'"
                >
                  {{ $t("message.标签分组") }}</el-menu-item
                >
                <el-menu-item
                  @click="
                    setTitle('兴趣标签');
                    setMenuIndex('/interestedtaglist');
                    setSubTitle('兴趣标签');
                  "
                  :index="'/interestedtaglist'"
                >
                  {{ $t("message.兴趣标签") }}</el-menu-item
                >
              </el-submenu>

            </el-menu>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="uname-box">
            <div style="width: 40px; height: 40px"></div>
            <!-- <img :src="'/rs/headimg?headImgId=' + imageUrl" alt="" style="max-width: 120px; max-height: 30px;border-radius:50%"> -->
            <el-popover
              placement="bottom-end"
              popper-class="uname-popover"
              :visible-arrow="false"
              width="160"
              trigger="click"
            >
              <el-badge slot="reference" style="" class="badgeItem">
                <el-button size="mini" type="info" round>{{ uname }}</el-button>
              </el-badge>
              <div class="uname-menu">
                <el-badge style="" :hidden="true" is-dot class="menubadgeItem">
                  <!-- <el-button
                    class="menu-button"
                    size="mini"
                    type=""
                    icon="el-icon-s-opportunity"
                  >
                    {{ $t("message.查看帮助文档") }}</el-button
                  > -->
                  <router-link to="/userCenter" class="rtl">
                    <el-button
                      class="menu-button"
                      size="mini"
                      type=""
                      icon="el-icon-s-opportunity"
                      @click="
                        setTitle('修改个人信息');
                        setSubTitle('设置');
                      "
                    >
                      {{ $t("message.修改个人信息") }}</el-button
                    >
                  </router-link>
                  <!-- <router-link to="/test" class="rtl"><el-button class="menu-button" size="mini" type="" icon="el-icon-s-opportunity" @click="setTitle('test');setSubTitle('设置')">
										test</el-button></router-link> -->
                  <router-link to="/enterpriseSettings" class="rtl"
                    ><el-button
                      class="menu-button"
                      size="mini"
                      type=""
                      icon="el-icon-s-opportunity"
                      @click="
                        setTitle('企业设置');
                        setSubTitle('设置');
                      "
                    >
                      {{ $t("message.企业设置") }}</el-button
                    ></router-link
                  >
                  <!-- <router-link to="/datares" class="rtl"
                    ><el-button
                      class="menu-button"
                      size="mini"
                      type=""
                      icon="el-icon-s-opportunity"
                      @click="
                        setTitle('元数据');
                        setSubTitle('设置');
                      "
                    >
                      {{ $t("message.元数据") }}</el-button
                    ></router-link
                  > -->
                  <!-- <router-link to="/autopage" class="rtl"><el-button class="menu-button" size="mini" type="" icon="el-icon-s-opportunity" @click="setTitle('autopage');setSubTitle('设置')">
										{{$t('message.自定义海报')}}</el-button></router-link> -->
                  <!-- <router-link to="/automaster" class="rtl">
                    <el-button
                      class="menu-button"
                      size="mini"
                      type=""
                      icon="el-icon-s-opportunity"
                      @click="
                        setTitle('autopage');
                        setSubTitle('设置');
                      "
                    >
                      {{ $t("message.自定义主页") }}</el-button
                    >
                  </router-link> -->
                </el-badge>
              </div>
            </el-popover>

            <el-button
              title="登出"
              class="logout-button"
              size="mini"
              type=""
              circle
              icon="el-icon-switch-button"
              @click="doLogout"
            ></el-button>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-container style="height: calc(100% - 60px)">
      <el-aside width="auto">
        <!-- <el-menu :default-active="menuIndex" class="el-menu-vertical-demo" :collapse="isCollapse"
				mode="horizontal"
					background-color="#f0f0f0" text-color="#333" :router="true">
					<el-menu-item @click="doCollapse">
						<i class="el-icon-caret-left" v-if="!isCollapse"></i>
						<i class="el-icon-caret-right" v-else></i>
						<span slot="title" v-if="!isCollapse">{{$t('message.折叠')}}</span>
						<span slot="title" v-else>{{$t('message.展开')}}</span>
					</el-menu-item>
					<el-menu-item @click="setTitle(''); setMenuIndex('/home');" :index="'/home'">
						<span slot="title">{{$t('message.首页')}}</span>
						<img class="logo" src="../assets/img/tbimg.png" alt="logo">
					</el-menu-item>

					<el-menu-item @click="setTitle('小美首页管理'); setMenuIndex('/homeEdit');" :index="'/homeEdit'">
						<i class="el-icon-s-home"></i>
						<span slot="title">{{$t('message.小美首页管理')}}</span>
					</el-menu-item>
					<el-menu-item @click="setTitle('小美福利管理'); setMenuIndex('/welfare');" :index="'/welfare'">
						<i class="el-icon-present"></i>
						<span slot="title">{{$t('message.小美福利管理')}}</span>
					</el-menu-item>
					<el-submenu index="1">
						<template slot="title">
							<i class="el-icon-table-lamp"></i>
							<span>{{$t('message.产品')}}</span>
						</template>
						<el-menu-item @click="setTitle('产品热搜榜管理'); setMenuIndex('/toplist');" :index="'/toplist'">
							{{$t('message.产品热搜榜管理')}}</el-menu-item>
						<el-menu-item @click="setTitle('产品分类管理'); setMenuIndex('/classifylist');"
							:index="'/classifylist'">{{$t('message.产品分类管理')}}</el-menu-item>
						<el-menu-item @click="setTitle('产品管理'); setMenuIndex('/productlist');" :index="'/productlist'">
							{{$t('message.产品管理')}}</el-menu-item>
					</el-submenu>
					<el-submenu index="2">
						<template slot="title">
							<i class="el-icon-collection"></i>
							<span>{{$t('message.品牌')}}</span>
						</template>
						<el-menu-item @click="setTitle('品牌详情类型管理'); setMenuIndex('/brandtypelist');"
							:index="'/brandtypelist'">{{$t('message.品牌详情类型管理')}}</el-menu-item>
						<el-menu-item @click="setTitle('品牌管理'); setMenuIndex('/brandlist');" :index="'/brandlist'">{{$t('message.品牌管理')}}
						</el-menu-item>
					</el-submenu>

					<el-submenu index="3">
						<template slot="title">
							<i class="el-icon-set-up"></i>
							<span>{{$t('message.运营工具')}}</span>
						</template>
						<el-menu-item @click="setTitle('标签管理'); setMenuIndex('/tagmanage');" :index="'/tagmanage'">
							{{$t('message.标签管理')}}
						</el-menu-item>
						<el-menu-item @click="setTitle('标签清洗'); setMenuIndex('/committag');" :index="'/committag'">
							{{$t('message.标签清洗')}}
						</el-menu-item>
						<el-menu-item @click="setTitle('第三方平台授权'); setMenuIndex('/preauth');" :index="'/preauth'">
							{{$t('message.第三方平台授权')}}
						</el-menu-item>
					</el-submenu>

					<el-submenu index="4">
						<template slot="title">
							<i class="el-icon-school"></i>
							<span>{{$t('message.组织架构')}}</span>
						</template>
						<el-menu-item @click="setTitle('组织管理'); setMenuIndex('/organization');" :index="'/organization'">
							<span slot="title">{{$t('message.组织管理')}}</span>
						</el-menu-item> 
						<el-menu-item @click="setTitle('员工管理'); setMenuIndex('/employee');" :index="'/employee'">
							{{$t('message.员工管理')}}
						</el-menu-item>
					</el-submenu>
				</el-menu> -->
      </el-aside>
      <el-container>
        <div class="breadcrumbContainer">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item><span>{{
                $t("message.首页")
              }}</span></el-breadcrumb-item
            >
            <el-breadcrumb-item v-if="subtitle">{{
              $t(`message.${subtitle}`)
            }}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="title">{{
              $t(`message.${title}`)
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-main>
          <router-view></router-view>
        </el-main>
        <el-footer height="30px"
          >Copyright © 2021-2030 WebPower. All Rights Reserved.</el-footer
        >
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import userCenter from "@/pages/usercenter/usercenter.vue";
export default {
  name: "maincontainer",
  data() {
    return {
      isCollapse: false,
      uid: "0001",
      uname: "Lance",
      mobile: "1333",
      isModifyInof: false,
      visible: false,
      imageUrl: "",
      defaultimg: "../../../static/images/tbimg.png",
    };
  },
  components: { userCenter },
  methods: {
    gotohomepage() {
      this.$router.push("/home");
      this.menuIndex = "/home";
      this.setTitle("");
    },
    // 获取用户信息
    getuserinfo() {
      // 登录
      rejecthttp(
        true,
        "get",
        "/manage/account/getaccountinfo",
        {
          appid: "188",
          userid: this.$store.state.uid,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.imageUrl = doc.data.data.headImg ? doc.data.data.headImg : "";
          }
        }
      );
    },
    gotest() {
      this.$router.push("/test");
    },
    goenterprisesettings() {
      // this.$router.push('/enterpriseSettings')
    },
    goUserCenter() {
      this.visible = true;
    },
    goout() {
      this.visible = false;
    },
    setTitle(t) {
      this.title = t;
      this.subtitle = "";
    },
    setSubTitle(t) {
      console.log(t);
      this.subtitle = t;
    },
    setMenuIndex(t) {
      this.menuIndex = t;
    },
    doCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    doLogout() {
      this.$http.post("/manage/logout").then((doc) => {
        if (doc.data.Code != "MSGKEY_OK") {
          this.$message({
            type: "error",
            message: doc.data.message,
          });
          // 删除
        }
        this.$store.commit("myUid", null);
        this.$router.push({
          name: "login",
        });
      });
    },
    onModifyInfo() {
      this.isModifyInof = !this.isModifyInof;
    },
    emitCloseModifyInfo(val) {
      this.isModifyInof = val;
    },
  },
  mounted() {
    this.uname = this.$store.state.uname;
    this.getuserinfo();
  },
  computed: {
    title: {
      get: function () {
        return this.$store.state.pageTitle;
      },
      set: function (newValue) {
        this.$store.commit("setPageTitle", newValue);
      },
    },
    subtitle: {
      get: function () {
        return this.$store.state.subPageTitle;
      },
      set: function (newValue) {
        this.$store.commit("setSubPageTitle", newValue);
      },
    },
    menuIndex: {
      get: function () {
        return this.$store.state.menuIndex;
      },
      set: function (index) {
        this.$store.commit("setMenuIndex", index);
      },
    },
  },
};
</script>

<style scoped>
.shadeuser {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
}

.headtitle {
  float: left;
  font-size: 14px;
  font-weight: bold;
  margin-left: 20px;
  color: hsla(0, 0%, 100%, 0.8);
  /* color: #333; */
}

.logo {
  float: left;
  height: 40px;
  margin-top: 5px;
}

.uname-box {
  margin-top: 12px;
  display: flex;
  color: hsla(0, 0%, 100%, 0.7);
  /* color: #333; */
  float: right;
  line-height: 0px;
  /* right: 200px; */
}

.menubadgeItem {
  margin-top: 2px;
  margin-right: 0px;
}

.menubadgeItem /deep/ .el-badge__content.is-fixed.is-dot {
  right: 1px;
  top: 14px;
}

.badgeItem {
  margin-top: 0px;
  margin-right: 20px;
}

.badgeItem /deep/ .el-badge__content.is-fixed.is-dot {
  right: 7px;
  top: 4px;
}

.tooltipItem {
  margin-top: 0px;
}

.uname-menu {
  /* display: flex; */
  flex-direction: column;
  width: 100%;
  text-align: left;
}

.menu-button {
  background-color: #434b51;
  padding: 8px;
  width: auto;
  color: hsla(0, 0%, 100%, 0.7);
  border: 0;
  margin-left: 0px;
  text-align: left;
}

.menu-button:hover {
  color: hsla(0, 0%, 100%, 1);
  background-color: #434b51;
}

.menu-button:focus {
  color: hsla(0, 0%, 100%, 1);
  background-color: #434b51;
}

.logout-button {
  background-color: #434b51;
  padding: 0px;
  /* margin-right: 2px; */
  height: 25px;
  font-size: 12px;
  color: hsla(0, 0%, 100%, 1);
  border: 0;
  /* border: 1px solid hsla(0, 0%, 100%, 0); */
}

/* .logout-button /deep/ .el-icon-switch-button {
  font-weight: bold !important;
} */
.logout-button:hover {
  color: hsla(0, 0%, 100%, 1);
  /* border: 1px solid hsla(0, 0%, 100%, 0.2); */
  background-color: hsla(0, 0%, 100%, 0.3);
}

.logout-button:focus {
  color: hsla(0, 0%, 100%, 1);
  /* border: 1px solid hsla(0, 0%, 100%, 0.2); */
  background-color: hsla(0, 0%, 100%, 0.3);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.iconfontFixed {
  position: fixed;
}

.iconfont {
  left: 18px;
  font-size: 16px;
}

.menuspan {
  position: fixed;
  left: 45px;
}

.el-header {
  background-color: #434b51;
  border-top-color: #0cc2a9;
  color: hsla(0, 0%, 100%, 0.7);
  text-align: center;
  line-height: 50px;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.el-footer {
  background-color: #d3dce6;
  border-top: 1px solid rgb(216, 208, 208);
  color: #333;
  text-align: center;
  line-height: 30px;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.el-aside {
  background-color: #f0f0f0;
  border-right: 1px solid #ddd;
  color: #333;
  /* text-align: center; */
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.el-main {
  position: relative;
  background-color: #e9eef3;
  color: #333;
  padding-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

body > .el-container {
  margin-bottom: 40px;
  height: 1000px;
}

.breadcrumbContainer {
  height: 40px;
  margin-left: 20px;
}

.breadcrumb {
  height: 30px;
  font-size: 12px;
  line-height: 40px;
}

/* .el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
} */
.rtl {
  color: #d0d2d3;
}

.rtl:hover {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/mainContainer.vue